import { c as _c } from "react/compiler-runtime";
import { ContextCurrencyFragment } from "@opensea/app-kit";
import { graphql, useQuery } from "@opensea/graphql";
import { NETWORK_ONLY_OPERATION_CONTEXT } from "../../../constants";
const SearchCurrenciesQuery = graphql(`
    query currenciesByQuery($query: String!, $limit: Int!, $chain: ChainIdentifier) {
      currenciesByQuery(query: $query, limit: $limit, allowlistOnly: false, chain: $chain) {
        name
        symbol
        imageUrl
        chain {
          identifier
        }
        contractAddress
        usdPrice
        decimals
        isSwapDisabled
        ...ContextCurrency
      }
    }
  `, [ContextCurrencyFragment]);
export const useSearchCurrenciesQuery = params => {
  const $ = _c(15);
  const {
    query,
    chain,
    pause
  } = params;
  const t0 = query;
  const t1 = chain && chain !== "all" ? chain : undefined;
  let t2;
  if ($[0] !== t0 || $[1] !== t1) {
    t2 = {
      query: t0,
      limit: 100,
      chain: t1
    };
    $[0] = t0;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const t3 = !query || pause;
  let t4;
  if ($[3] !== t2 || $[4] !== t3) {
    t4 = {
      query: SearchCurrenciesQuery,
      variables: t2,
      pause: t3,
      context: NETWORK_ONLY_OPERATION_CONTEXT
    };
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const [t5, refetch] = useQuery(t4);
  const {
    data,
    error,
    fetching
  } = t5;
  let t6;
  if ($[6] !== data?.currenciesByQuery) {
    t6 = data?.currenciesByQuery ?? [];
    $[6] = data?.currenciesByQuery;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== refetch) {
    t7 = () => refetch({
      requestPolicy: "network-only"
    });
    $[8] = refetch;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== error || $[11] !== fetching || $[12] !== t6 || $[13] !== t7) {
    t8 = {
      currencies: t6,
      error,
      fetching,
      refetch: t7
    };
    $[10] = error;
    $[11] = fetching;
    $[12] = t6;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  return t8;
};